import React, { useEffect } from "react";
import Banner from "../Components/banner/Banner";
import BannerData from "../models/BannersData";
import BreadcrumbsComponent from "../Components/common/BreadcrumbsComponent";
import TitleComponent from "../Components/common/TitleComponent";
import CategoriesData from "../models/CategoriesData";
import CategoriesCard from "../Components/card/CategoriesCard";
import SubFooterBar from "../Components/common/SubFooterBar";
import Masonry from "react-masonry-css";
import Background1 from "../Components/background/Background1";
import FloatingImageSrc from "../assets/images/Decorations/bg-leaf2.png";

const CategoriesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const BreadCrumbsPath = [
    {
      id: 1,
      pathName: "Categories",
      pathLink: "/Categories",
    },
  ];

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
  };

  const description =
    "Welcome to Ceylon Hospital's wellness hub, where we blend modern healthcare with the art of relaxation and rejuvenation. Explore our comprehensive range of treatments under five distinct categories: Mind Relax, offering therapies to ease stress and enhance mental clarity; Beauty, designed to revitalize and uplift your natural glow; Health, providing tailored programs for physical well-being and recovery; Touch, where soothing massages restore balance and energy; and Luxurious Experience, indulging you in premium spa and wellness treatments. Let us guide you on a transformative journey to nurture your body, mind, and spirit. Visit our website to begin your path to holistic wellness.";

  return (
    <>
      {BannerData.filter((item) => item.title === "Categories").map((item) => (
        <Banner key={item.id} bannerDetails={item} />
      ))}

      <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

      <TitleComponent
        Title={"Main Treatment Categories"}
        Subtitle={"All the treatments are grouped into main categories."}
      />

      <div className="relative my-3">
        <Background1 />
        <img
          alt="floating-icon"
          className="absolute -top-12 lg:-top-16 -mr-6 lg:right-6 -z-10 w-auto h-64 object-cover shadow-none rotate-[-60deg] animate-float"
          src={FloatingImageSrc}
        />

        <div className="-mt-[95vh] px-5 md:px-12 lg:px-24">
          {/* Main category description */}
          <div className="w-full pb-6">
            <p className="p-2 text_CormorantGaramond-Regular text-center text-4xl uppercase text-customMaroon-30">
              Discover Wellness at Ceylon Hospital
            </p>
            <div>
              <p className="text-black leading-tight text-center description_AlegreyaSans-Light">
                {description}
              </p>
            </div>
          </div>
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="flex -ml-5"
            columnClassName="pl-5"
          >
            {CategoriesData.map((item, index) => (
              <div key={index} className="py-2">
                <CategoriesCard categoryDetails={item} />
              </div>
            ))}
          </Masonry>
        </div>
      </div>

      <SubFooterBar />
    </>
  );
};

export default CategoriesPage;
